export abstract class ProfileAccessStorage {
  abstract saveAccess(profileId: string, code: string): Promise<void>;
  abstract getCode(profileId: string): Promise<string | null>;
}
